import styles from './styles.module.scss';

const SidebarFilter = ({ children }) => {
  return <div className={styles.sidebarFilter}>
    {children}
  </div>
}

export default SidebarFilter;